"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _moment = _interopRequireDefault(require("moment"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
function formatDate(date) {
  if ((0, _isNil.default)(date) || date === '') {
    return '- -';
  }
  return (0, _moment.default)(date).format('MM/DD/YYYY');
}
var _default = formatDate;
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(formatDate, "formatDate", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/stores/common/format-date.js");
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/stores/common/format-date.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJmb3JtYXREYXRlIiwiZGF0ZSIsImlzTmlsIiwibW9tZW50IiwiZm9ybWF0Il0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3N0b3Jlcy9jb21tb24vZm9ybWF0LWRhdGUuanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGlzTmlsIGZyb20gJ2xvZGFzaC9pc05pbCc7XG5pbXBvcnQgbW9tZW50IGZyb20gJ21vbWVudCc7XG5cbmZ1bmN0aW9uIGZvcm1hdERhdGUoZGF0ZSkge1xuXHRpZiAoaXNOaWwoZGF0ZSkgfHwgZGF0ZSA9PT0gJycpIHtcblx0XHRyZXR1cm4gJy0gLSc7XG5cdH1cblxuXHRyZXR1cm4gbW9tZW50KGRhdGUpLmZvcm1hdCgnTU0vREQvWVlZWScpO1xufVxuXG5leHBvcnQgZGVmYXVsdCBmb3JtYXREYXRlO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7QUFDQTtBQUE0QjtFQUFBO0VBQUE7QUFBQTtBQUFBO0VBQUE7QUFBQTtBQUU1QixTQUFTQSxVQUFVLENBQUNDLElBQUksRUFBRTtFQUN6QixJQUFJLElBQUFDLGNBQUssRUFBQ0QsSUFBSSxDQUFDLElBQUlBLElBQUksS0FBSyxFQUFFLEVBQUU7SUFDL0IsT0FBTyxLQUFLO0VBQ2I7RUFFQSxPQUFPLElBQUFFLGVBQU0sRUFBQ0YsSUFBSSxDQUFDLENBQUNHLE1BQU0sQ0FBQyxZQUFZLENBQUM7QUFDekM7QUFBQyxlQUVjSixVQUFVO0FBQUE7QUFBQTtBQUFBO0FBQUE7RUFBQTtFQUFBO0lBQUE7RUFBQTtFQUFBLHdCQVJoQkEsVUFBVTtFQUFBO0FBQUE7QUFBQTtBQUFBO0VBQUE7RUFBQTtBQUFBIn0=